import { clearRecentQueries, registerRecentQueries, } from '../../recent-queries/recent-queries-actions.js';
import { recentQueriesReducer as recentQueries } from './recent-queries-slice.js';
/**
 * Loads the recent queries reducer and returns available commerce recent queries actions.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the commerce recent queries action creators.
 *
 * @group Actions
 * @category RecentQueries
 */
export function loadRecentQueriesActions(engine) {
    engine.addReducers({ recentQueries });
    return {
        registerRecentQueries,
        clearRecentQueries,
    };
}
